import Vue from 'vue'
import Vuex from 'vuex'

import assessments from './assessments'
import persons from './persons'
import statistics from './statistics'
import reports from './reports'
import fieldOptions from './fieldOptions'
import organization from './organization'
import note from './note'
import advocate from './advocate'
import user from './user'
import usermember from './usermember'
import api from './api'
import group from './group'
import sharing from './sharing'
import externalids from './externalids'
import log from './log'
import transfer from './transfer'
import cseit from './cseit'
import program from './program'
import location from './location'
import file from './file'
import laborscreenings from './laborScreening'
import oldtraffickingscreenings from './oldTraffickingScreening'
import traffickingscreenings from './traffickingScreening'
import annualData from './annualData'
import auth from './auth'
import userreport from './userreport'
import victimInfo from './victimInfo'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    assessments,
    persons,
    statistics,
    reports,
    fieldOptions,
    organization,
    notes: note,
    advocate,
    user,
    usermember,
    group,
    api,
    sharing,
    externalids,
    log,
    transfer,
    cseit,
    program,
    location,
    file,
    laborscreenings,
    oldtraffickingscreenings,
    traffickingscreenings,
    annualData,
    auth,
    userreport,
    victimInfo
  }
})

export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export function resetState () {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}



// WEBPACK FOOTER //
// ./src/store/index.js